// src/pages/SalonDetails/index.js
import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { TabButton } from '../../components/common/Button';
import ServiceItem from '../../components/ui/ServiceItem';
import SpecialistItem from '../../components/ui/SpecialistItem';
import ReviewItem from '../../components/ui/ReviewItem';
import { 
  StarIcon, 
  ArrowLeftIcon, 
  HeartIcon, 
  CameraIcon,
  MapPinIcon
} from '../../components/common/Icons';

const SalonDetails = () => {
  const { selectedSalon, navigateTo } = useApp();
  const [activeTab, setActiveTab] = useState('services');
  
  if (!selectedSalon) return <div>Loading...</div>;
  
  // Sample services data
  const services = [
    {
      id: 1,
      name: "TUNS",
      duration: "45 min",
      price: "50 lei",
      description: "Tunsoare clasică sau modernă."
    },
    {
      id: 2,
      name: "TUNS + TUNS BARBĂ",
      duration: "45m - 1h",
      price: "70 lei",
      description: "Avem grijă ca părul și barba ta să arate bine, la cel mai înalt nivel!"
    },
    {
      id: 3,
      name: "TUNS + SPĂLAT & ARANJAT",
      duration: "45m - 1h",
      price: "70 lei",
      description: "Un refresh look-ului tău de zi cu zi!"
    }
  ];

  // Sample specialists data
  const specialists = [
    {
      id: 1,
      name: "Remus Bezea",
      position: "Specialist",
      available: true,
      price: "50 lei",
      duration: "45 min",
      image: "/api/placeholder/80/80"
    },
    {
      id: 2,
      name: "Cristi Gâtlan",
      position: "Specialist",
      available: true,
      price: "50 lei",
      duration: "45 min",
      image: "/api/placeholder/80/80"
    },
    {
      id: 3,
      name: "Alexandru Totolici",
      position: "Profil privat",
      available: true,
      price: "50 lei",
      duration: "45 min",
      image: "/api/placeholder/80/80",
      needsRegistration: true
    }
  ];

  // Sample reviews data
  const reviews = [
    {
      id: 1,
      name: "Dorin C.",
      rating: 5,
      comment: "O experiență de nota 10",
      image: "/api/placeholder/40/40"
    },
    {
      id: 2,
      name: "Alex H.",
      rating: 5,
      comment: "Singurul frizer care a plecat de la 0 și tot acolo a rămas =))",
      image: "/api/placeholder/40/40"
    }
  ];
  
  return (
    <div className="flex-1 overflow-y-auto pb-4">
      <header className="relative">
        <div className="flex justify-between absolute top-4 left-4 right-4 z-10">
          <button 
            className="bg-white rounded-full p-2 shadow"
            onClick={() => navigateTo('home')}
          >
            <ArrowLeftIcon size={24} />
          </button>
          <div className="flex">
            <button className="bg-white rounded-full p-2 shadow mr-2">
              <HeartIcon size={24} />
            </button>
            <button className="bg-white rounded-full p-2 shadow">
              <CameraIcon size={24} />
            </button>
          </div>
        </div>
        <div className="flex">
          <img src="/api/placeholder/200/200" alt="" className="w-1/2 h-48 object-cover" />
          <img src="/api/placeholder/200/200" alt="" className="w-1/2 h-48 object-cover" />
        </div>
        <div className="p-4 bg-white">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold">{selectedSalon.name}</h1>
            <div className="bg-white rounded-full p-2 border">
              <img src="/api/placeholder/30/30" alt="Logo" className="w-6 h-6" />
            </div>
          </div>
          <div className="flex items-center my-2">
            <StarIcon size={16} fill="#FFD700" stroke="#FFD700" className="mr-1" />
            <span className="font-bold">{selectedSalon.rating}</span>
            <span className="text-gray-500 text-sm ml-1">({selectedSalon.reviews} evaluări)</span>
          </div>
          <p className="text-gray-600 text-sm">{selectedSalon.address}</p>
        </div>
        
        <div className="flex bg-gray-100 p-1 rounded-lg mx-4">
          <TabButton 
            title="SERVICII" 
            isActive={activeTab === 'services'} 
            onClick={() => setActiveTab('services')} 
          />
          <TabButton 
            title="SPECIALIȘTI" 
            isActive={activeTab === 'specialists'} 
            onClick={() => setActiveTab('specialists')} 
          />
          <TabButton 
            title="RECENZII" 
            isActive={activeTab === 'reviews'} 
            onClick={() => setActiveTab('reviews')} 
          />
          <TabButton 
            title="CONTACT" 
            isActive={activeTab === 'contact'} 
            onClick={() => setActiveTab('contact')} 
          />
        </div>
      </header>

      <section className="p-4">
        {activeTab === 'services' && (
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow overflow-hidden">
              <div className="p-4 font-bold text-lg border-b">BARBERSHOP</div>
              {services.map((service) => (
                <ServiceItem 
                  key={service.id}
                  name={service.name} 
                  duration={service.duration} 
                  price={service.price}
                  description={service.description}
                  onClick={() => navigateTo('specialists', { 
                    salon: selectedSalon, 
                    service
                  })}
                />
              ))}
            </div>
          </div>
        )}
        
        {activeTab === 'specialists' && (
          <div className="space-y-4">
            {specialists.map((specialist) => (
              <SpecialistItem 
                key={specialist.id}
                name={specialist.name} 
                position={specialist.position} 
                available={specialist.available}
                price={specialist.price}
                duration={specialist.duration}
                image={specialist.image}
                needsRegistration={specialist.needsRegistration}
                onClick={() => navigateTo('selectDate', { 
                  salon: selectedSalon, 
                  specialist
                })}
              />
            ))}
          </div>
        )}
        
        {activeTab === 'reviews' && (
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow p-4">
              <div className="text-4xl font-bold text-center">{selectedSalon.rating}</div>
              <div className="flex justify-center my-2">
                {[1, 2, 3, 4, 5].map((i) => (
                  <StarIcon key={i} size={20} fill="#FFD700" stroke="#FFD700" />
                ))}
              </div>
              <div className="text-center text-gray-500">{selectedSalon.reviews} evaluări</div>
            </div>
            
            {reviews.map((review) => (
              <ReviewItem 
                key={review.id}
                name={review.name} 
                rating={review.rating} 
                comment={review.comment}
                image={review.image}
              />
            ))}
          </div>
        )}
        
        {activeTab === 'contact' && (
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow p-4">
              <img src="/api/placeholder/400/200" alt="Map" className="w-full h-40 object-cover rounded-lg mb-4" />
              <button className="bg-blue-100 text-blue-600 w-full py-3 rounded-lg font-medium">Vezi direcții de navigare</button>
              
              <div className="mt-4 border-t pt-4">
                <div className="flex items-start mb-3">
                  <MapPinIcon size={20} className="mr-2 text-gray-500 mt-1" />
                  <div>
                    <p className="text-gray-800">{selectedSalon.address}</p>
                    <p className="text-gray-600 text-sm">Primul bloc pe stanga, inainte de sens unic.</p>
                  </div>
                </div>
                
                <div className="mb-3">
                  <h3 className="text-gray-500 mb-2">Program de lucru</h3>
                  <div className="flex justify-between py-1">
                    <span>Luni</span>
                    <span>Închis</span>
                  </div>
                  <div className="flex justify-between py-1">
                    <span>Marți</span>
                    <span>9:00 - 20:00</span>
                  </div>
                  <div className="flex justify-between py-1">
                    <span>Miercuri (azi)</span>
                    <span>9:00 - 20:00</span>
                  </div>
                  <div className="flex justify-between py-1">
                    <span>Joi</span>
                    <span>9:00 - 20:00</span>
                  </div>
                  <div className="flex justify-between py-1">
                    <span>Vineri</span>
                    <span>9:00 - 20:00</span>
                  </div>
                  <div className="flex justify-between py-1">
                    <span>Sâmbătă</span>
                    <span>9:00 - 17:00</span>
                  </div>
                  <div className="flex justify-between py-1">
                    <span>Duminică</span>
                    <span>Închis</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default SalonDetails;